<template>
  <div
    class="navbar is-block"
    style="border: none;"
  >
    <download-app-notif></download-app-notif>
    <nav
      class="has-background-primary"
      style="width: 100%; padding: 2px 0; background-image: url(/assets/img/base.png); background-position: center; background-repeat: no-repeat;"
    >
      <div class="container is-fluid">
        <div
          class="columns is-vcentered"
          style="width: 100%;"
        >
          <div class="column">
            <div class="columns is-vcentered">
              <div
                class="column is-narrow"
                style="padding-right: 0;"
              >
                <nuxt-link
                  :to="{path: '/panel'}"
                  class="navbar-item is-bg-transparent"
                >
                  <img
                    v-if="!isEmpty($store.state.universities.active)"
                    :src="$store.state.universities.active.logoRightText"
                    style="max-height: 45px;"
                  />
                  <img
                    v-else
                    src="/assets/img/logo-white-new.png"
                    style="width: 95px; max-height: 45px;"
                  />
                </nuxt-link>

                <a
                  role="button"
                  class="navbar-burger has-text-white"
                  aria-label="menu"
                  aria-expanded="false"
                  :class="show_mobile_menu ? 'is-active' : ''"
                  @click.prevent="show_mobile_menu = !show_mobile_menu"
                >
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                </a>
              </div>

              <div
                class="column"
                style="padding-left: 0;"
              >
                <div
                  v-if="!isEmpty(pt) && !isEmpty(pt.university)"
                  class="font-w-400 has-text-lightprimary font-14"
                  style="font-family: Bree Serif;"
                >
                  {{ pt.university.name }}
                </div>
                <div
                  v-else-if="!isEmpty(user.universityName)"
                  class="font-w-400 has-text-lightprimary font-14"
                  style="font-family: Bree Serif;"
                >
                  {{ user.universityName }}
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="columns is-vcentered">
              <div class="column">
                <div class="columns is-vcentered is-gapless is-centered">
                  <div class="column">
                    <div class="columns">
                      <div
                        class="column has-text-centered"
                        :style="$route.name == 'panel' ? 'border-top: 3px solid #FFAD23;margin-top: -2px;' : ''"
                      >
                        <nuxt-link
                          :to="{name: 'panel'}"
                          class="button is-text font-w-600 font-14 is-no-box-shadow"
                          style="background: transparent;"
                        >
                          <span class="icon">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21.1667 9.99151L11.4541 0.681927C11.2009 0.439358 10.7991 0.439358 10.5459 0.681927L0.822998 10.0021C0.61824 10.2068 0.5 10.4917 0.5 10.7804C0.5 11.3841 0.990906 11.8737 1.59332 11.8737H3.125V20.1871C3.125 20.9116 3.713 21.4996 4.4375 21.4996H8.15582C8.51791 21.4996 8.81207 21.2054 8.81207 20.8434V15.1563C8.81207 15.0355 8.91045 14.9371 9.03125 14.9371H12.9688C13.0896 14.9371 13.1879 15.0355 13.1879 15.1563V20.8434C13.1879 21.2054 13.4821 21.4996 13.8442 21.4996H17.5625C18.287 21.4996 18.875 20.9116 18.875 20.1871V11.875H20.4067C21.0104 11.875 21.5 11.3841 21.5 10.7817C21.5 10.4917 21.3818 10.2068 21.1667 9.99151Z"
                                fill="#C6E8C5"
                              />
                              <path
                                d="M8.375 21.4996H13.625V15.8125C13.625 15.088 13.037 14.5 12.3125 14.5H9.6875C8.963 14.5 8.375 15.088 8.375 15.8125V21.4996Z"
                                fill="#82BC81"
                              />
                            </svg>
                          </span>
                          <span :class="{'has-text-white': $route.name == 'panel', 'has-text-lightprimary': $route.name != 'panel'}">&nbsp;&nbsp;&nbsp;Beranda</span>
                        </nuxt-link>
                      </div>
                      <div
                        class="column has-text-centered"
                        :style="$route.name == 'panel-classes' ? 'border-top: 3px solid #FFAD23;margin-top: -2px;' : ''"
                      >
                        <nuxt-link
                          :to="{name: 'panel-classes'}"
                          class="button is-text font-w-600 font-14 is-no-box-shadow"
                          style="background: transparent;"
                        >
                          <span class="icon">
                            <svg
                              width="21"
                              height="21"
                              viewBox="0 0 21 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.9375 5.46924V1.53174C3.9375 1.30468 3.96375 1.08549 4.02544 0.875488H1.53169C0.691687 0.875488 0 1.56586 0 2.40586V6.34336C0 7.18336 0.691687 7.87505 1.53169 7.87505H1.85587L2.97544 9.36211C3.0975 9.51961 3.28125 9.61543 3.47419 9.62461H3.50044C3.69337 9.62461 3.86794 9.54586 3.99 9.39755L5.3025 7.9013C4.48875 7.39336 3.9375 6.49299 3.9375 5.46924Z"
                                fill="#C6E8C5"
                              />
                              <path
                                d="M19.4683 0.875488H16.9746C17.0363 1.08549 17.0625 1.30336 17.0625 1.53174V5.46924C17.0625 6.49299 16.5113 7.39468 15.6975 7.9013L17.01 9.39755C17.1321 9.54586 17.3079 9.62461 17.4996 9.62461H17.5258C17.7188 9.61543 17.9025 9.51961 18.0246 9.36211L19.1363 7.87505H19.4683C20.3083 7.87505 21 7.18336 21 6.34336V2.40586C21 1.56586 20.3083 0.875488 19.4683 0.875488Z"
                                fill="#C6E8C5"
                              />
                              <path
                                d="M10.5 8.75044C10.4921 8.75044 10.4842 8.75044 10.4751 8.75044C10.2769 8.74256 10.0931 8.64675 9.975 8.48794L8.85937 7.00087H6.78169C5.93775 7.00087 5.25 6.31444 5.25 5.46919V1.53169C5.25 0.686437 5.93644 0 6.78169 0H14.2196C15.0636 0 15.75 0.686437 15.75 1.53169V5.46919C15.75 6.31312 15.0636 7.00087 14.2183 7.00087H12.3283L10.9935 8.526C10.8688 8.66775 10.689 8.75044 10.5 8.75044Z"
                                fill="#C6E8C5"
                              />
                              <path
                                d="M3.50042 14.8746C4.46667 14.8746 5.24998 14.0913 5.24998 13.1251C5.24998 12.1588 4.46667 11.3755 3.50042 11.3755C2.53416 11.3755 1.75085 12.1588 1.75085 13.1251C1.75085 14.0913 2.53416 14.8746 3.50042 14.8746Z"
                                fill="#82BC81"
                              />
                              <path
                                d="M5.83669 16.1004C4.95337 16.7659 4.37587 17.8329 4.37587 19.0313V19.2504H0.65625C0.297937 19.2504 0 18.9525 0 18.5942V18.1571C0 16.8262 1.07625 15.75 2.40581 15.75H4.59375C5.04919 15.75 5.47706 15.8813 5.83669 16.1004Z"
                                fill="#82BC81"
                              />
                              <path
                                d="M17.4996 14.8746C18.4658 14.8746 19.2491 14.0913 19.2491 13.1251C19.2491 12.1588 18.4658 11.3755 17.4996 11.3755C16.5333 11.3755 15.75 12.1588 15.75 13.1251C15.75 14.0913 16.5333 14.8746 17.4996 14.8746Z"
                                fill="#82BC81"
                              />
                              <path
                                d="M21 18.1558V18.5929C21 18.9512 20.7021 19.2491 20.3438 19.2491H16.6255V19.0313C16.6255 17.8329 16.048 16.7646 15.1647 16.1004C15.523 15.8813 15.9509 15.75 16.4063 15.75H18.5942C19.9238 15.75 21 16.8263 21 18.1558Z"
                                fill="#82BC81"
                              />
                              <path
                                d="M10.5 15.313C11.9497 15.313 13.125 14.1377 13.125 12.688C13.125 11.2382 11.9497 10.063 10.5 10.063C9.05025 10.063 7.875 11.2382 7.875 12.688C7.875 14.1377 9.05025 15.313 10.5 15.313Z"
                                fill="#82BC81"
                              />
                              <path
                                d="M12.9058 16.6255H8.09289C6.76595 16.6255 5.68707 17.7044 5.68707 19.0313V20.3438C5.68707 20.7061 5.98107 21.0001 6.34332 21.0001H14.6554C15.0177 21.0001 15.3117 20.7061 15.3117 20.3438V19.0313C15.313 17.7044 14.2328 16.6255 12.9058 16.6255Z"
                                fill="#82BC81"
                              />
                            </svg>

                          </span>
                          <span :class="{'has-text-white': $route.name == 'panel-classes', 'has-text-lightprimary': $route.name != 'panel-classes'}">&nbsp;&nbsp;&nbsp;Ruang Kelas</span>
                        </nuxt-link>
                      </div>
                      <div
                        class="column has-text-centered"
                        :style="$route.name == 'panel-messages' ? 'border-top: 3px solid #FFAD23;margin-top: -2px;' : ''"
                      >
                        <nuxt-link
                          :to="{name: 'panel-messages'}"
                          class="button is-text font-w-600 font-14 is-no-box-shadow"
                          style="background: transparent;"
                        >
                          <span class="icon">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19.1189 5.97852H18.6863V10.316C18.6863 12.4567 17.0353 14.1961 15.0062 14.1961H4.83099V16.2505C4.83099 17.6351 5.89879 18.7609 7.2121 18.7609H8.29418V20.8153C8.29418 21.0975 8.45786 21.3508 8.70857 21.4536C8.78521 21.4851 8.86445 21.5001 8.94369 21.5001C9.12166 21.5001 9.29702 21.4221 9.42173 21.2783L11.6106 18.7609H19.1189C20.4322 18.7609 21.5 17.6351 21.5 16.2505V8.48898C21.5 7.10569 20.4322 5.97852 19.1189 5.97852Z"
                                fill="#82BC81"
                              />
                              <path
                                d="M15.0049 0.5H2.44853C1.37424 0.5 0.5 1.42174 0.5 2.55439V10.3159C0.5 11.4485 1.37424 12.3703 2.44853 12.3703H15.0062C16.0805 12.3703 16.9547 11.4485 16.9547 10.3159V2.55439C16.9534 1.42174 16.0792 0.5 15.0049 0.5ZM15.2218 4.554L9.3853 7.53972C9.17746 7.64928 8.95273 7.70407 8.7267 7.70407C8.50067 7.70407 8.27594 7.64928 8.0681 7.53972L2.2316 4.554V3.03923L8.63187 6.30845C8.69293 6.34543 8.76177 6.34543 8.82283 6.30845L15.2231 3.03923V4.554H15.2218Z"
                                fill="#C6E8C5"
                              />
                            </svg>

                          </span>
                          <span :class="{'has-text-white': $route.name == 'panel-messages', 'has-text-lightprimary': $route.name != 'panel-messages'}">&nbsp;&nbsp;&nbsp;Obrolan</span>
                        </nuxt-link>
                      </div>
                      <div
                        v-if="!(user.is_admin || (!isEmpty(pt) && pt.type == 'ADMIN') || !isEmpty(user.permissionNames))"
                        class="column has-text-centered"
                        :style="$route.name == 'panel-groups-explore' ? 'border-top: 3px solid #FFAD23;margin-top: -2px;' : ''"
                      >
                        <nuxt-link
                          :to="{name: 'panel-groups-explore'}"
                          class="button is-text font-w-600 font-14 is-no-box-shadow"
                          style="background: transparent;"
                        >
                          <span class="icon">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21.0704 0.501833C16.9713 0.428335 12.2959 2.57028 9.33611 5.89476C6.50753 5.94857 3.75377 7.10748 1.72586 9.13524C1.60773 9.25205 1.56573 9.4253 1.61692 9.58279C1.66942 9.74029 1.80593 9.85578 1.97131 9.87941L5.34329 10.3624L4.92721 10.8283C4.77232 11.0016 4.7802 11.2654 4.94427 11.4294L10.5686 17.0534C10.6539 17.1387 10.7655 17.182 10.8784 17.182C10.9821 17.182 11.0871 17.1452 11.1698 17.0704L11.6357 16.6544L12.1187 20.0261C12.1424 20.1901 12.2723 20.3109 12.4285 20.3634C12.4692 20.3765 12.5112 20.3831 12.5532 20.3831C12.6766 20.3831 12.8039 20.3293 12.8919 20.2426C14.8922 18.2438 16.0499 15.4902 16.1037 12.6618C19.4324 9.69698 21.5915 5.02328 21.497 0.928385C21.4931 0.696078 21.3041 0.508396 21.0704 0.501833ZM17.0382 8.05508C16.6117 8.48163 16.0512 8.69425 15.492 8.69425C14.9316 8.69425 14.3711 8.48163 13.9445 8.05508C13.0927 7.20198 13.0927 5.8147 13.9445 4.9616C14.7977 4.10849 16.1851 4.10849 17.0382 4.9616C17.8914 5.8147 17.8914 7.20198 17.0382 8.05508Z"
                                fill="#C6E8C5"
                              />
                              <path
                                d="M2.88353 15.2909C1.94636 16.2267 0.661359 20.4581 0.51829 20.9372C0.47235 21.092 0.514352 21.2587 0.628545 21.3716C0.711236 21.4556 0.822805 21.5002 0.936999 21.5002C0.979001 21.5002 1.021 21.4936 1.063 21.4818C1.54209 21.3388 5.77249 20.0526 6.70966 19.1155C7.76496 18.0602 7.76496 16.3448 6.70966 15.2909C5.65436 14.2357 3.93883 14.237 2.88353 15.2909Z"
                                fill="#82BC81"
                              />
                            </svg>

                          </span>
                          <span :class="{'has-text-white': $route.name == 'panel-groups-explore', 'has-text-lightprimary': $route.name != 'panel-groups-explore'}">&nbsp;&nbsp;&nbsp;Jelajah</span>
                        </nuxt-link>
                      </div>

                      <!-- ADMIN PT MENUS -->
                      <div
                        v-if="!isEmpty(pt) && pt.type == 'ADMIN'"
                        class="column has-text-centered"
                        :style="$route.name == 'panel-admin-classes' ? 'border-top: 3px solid #FFAD23;margin-top: -2px;' : ''"
                      >
                        <b-dropdown
                          hoverable
                          aria-role="list"
                        >
                          <a
                            slot="trigger"
                            href=""
                            class="button is-text font-w-600 font-14 is-no-box-shadow"
                            style="background: transparent;"
                            @click.prevent=""
                          >
                            <span class="icon">
                              <i
                                class="fas fa-building fa-lg"
                                style="color: #C6E8C5;"
                              ></i>
                            </span>
                            <span :class="{'has-text-white': $route.name == 'panel-admin-classes', 'has-text-lightprimary': $route.name != 'panel-admin-classes'}">&nbsp;&nbsp;&nbsp;Perguruan Tinggi</span>
                          </a>

                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-classes'}">
                              Data Kelas
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-accounts'}">
                              Data Pengguna
                            </nuxt-link>
                          </b-dropdown-item>
                          <hr class="dropdown-divider">
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-spadaindonesiastats'}">
                              Dashboard Aktifitas Pembelajaran
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="user.activeAccount.university.siakad === 'siakadcloud'"
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-learningactivity'}">
                              Dashboard Perkuliahan <b-tag
                                type="is-info"
                                class="font-12 animated bounce"
                              >
                                Baru
                              </b-tag>
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-reports-teacher-posts'}">
                              Laporan Aktifitas Dosen
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-reports-teachers'}">
                              Laporan Kelas
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-conferences'}">
                              Laporan Video Conference
                            </nuxt-link>
                          </b-dropdown-item>
                          <hr class="dropdown-divider">
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-news'}">
                              Berita Kampus
                            </nuxt-link>
                          </b-dropdown-item>
                          <hr class="dropdown-divider">
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-settings'}">
                              Pengaturan
                            </nuxt-link>
                          </b-dropdown-item>
                          <hr class="dropdown-divider">
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-admin-spadaindonesia'}">
                              Spada Indonesia
                            </nuxt-link>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>

                      <!-- ADMIN EdLink -->
                      <div
                        v-if="!isEmpty(user.permissionNames)"
                        class="column has-text-centered"
                        :style="$route.name == 'panel-reports-postnews' ? 'border-top: 3px solid #FFAD23;margin-top: -2px;' : ''"
                      >
                        <b-dropdown
                          hoverable
                          aria-role="list"
                        >
                          <a
                            slot="trigger"
                            href=""
                            class="button is-text font-w-600 font-14 is-no-box-shadow"
                            style="background: transparent;"
                            @click.prevent=""
                          >
                            <span class="icon">
                              <i
                                class="fas fa-list fa-lg"
                                style="color: #C6E8C5;"
                              ></i>
                            </span>
                            <span :class="{'has-text-white': $route.name == 'panel-reports-postnews', 'has-text-lightprimary': $route.name != 'panel-reports-postnews'}">&nbsp;&nbsp;&nbsp;Lainnya</span>
                          </a>

                          <b-dropdown-item
                            v-if="user.permissionNames.indexOf('user_can_view_all_postnews') > -1"
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-reports-postnews'}">
                              Data Berita
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="user.permissionNames.indexOf('user_can_delete_other_user_comment') > -1"
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-reports-comments'}">
                              Data Komentar
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="user.permissionNames.indexOf('user_can_view_list_users') > -1"
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-users'}">
                              Data Pengguna Edlink
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="user.permissionNames.indexOf('user_can_view_list_universities') > -1"
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-reports'}">
                              Data Perguruan Tinggi
                            </nuxt-link>
                          </b-dropdown-item>
                          <hr
                            v-if="user.permissionNames.indexOf('user_can_view_list_accounts') > -1"
                            class="dropdown-divider"
                          >
                          <b-dropdown-item
                            v-if="user.permissionNames.indexOf('user_can_view_list_accounts') > -1"
                            aria-role="listitem"
                          >
                            <strong>SIAKAD</strong>
                          </b-dropdown-item>
                          <hr
                            v-if="user.permissionNames.indexOf('user_can_view_list_accounts') > -1"
                            class="dropdown-divider"
                          >
                          <b-dropdown-item
                            v-if="user.permissionNames.indexOf('user_can_view_list_accounts') > -1"
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-accounts'}">
                              Data Pengguna Siakad
                            </nuxt-link>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>


                      <!-- SUPERADMIN MENUS -->
                      <div
                        v-if="user.is_admin"
                        class="column has-text-centered"
                        :style="$route.name == 'panel-admin-classes' ? 'border-top: 3px solid #FFAD23;margin-top: -2px;' : ''"
                      >
                        <b-dropdown
                          hoverable
                          aria-role="list"
                        >
                          <a
                            slot="trigger"
                            href=""
                            class="button is-text font-w-600 font-14 is-no-box-shadow"
                            style="background: transparent;"
                            @click.prevent=""
                          >
                            <span class="icon">
                              <i
                                class="fas fa-users-cog fa-lg"
                                style="color: #C6E8C5;"
                              ></i>
                            </span>
                            <span :class="{'has-text-white': $route.name == 'panel-admin-classes', 'has-text-lightprimary': $route.name != 'panel-admin-classes'}">&nbsp;&nbsp;&nbsp;Superadmin</span>
                          </a>

                          <b-dropdown-item aria-role="listitem">
                            <strong>EDLINK</strong>
                          </b-dropdown-item>
                          <hr class="dropdown-divider">
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-users'}">
                              Data Pengguna Edlink
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-reports'}">
                              Data Perguruan Tinggi
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-reports-posts'}">
                              Data Postingan
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-reports-stats'}">
                              Laporan Aktifitas
                            </nuxt-link>
                          </b-dropdown-item>
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-system-packages'}">
                              Paket
                            </nuxt-link>
                          </b-dropdown-item>
                          <hr class="dropdown-divider">
                          <b-dropdown-item aria-role="listitem">
                            <strong>SIAKAD</strong>
                          </b-dropdown-item>
                          <hr class="dropdown-divider">
                          <b-dropdown-item
                            aria-role="listitem"
                            has-link
                          >
                            <nuxt-link :to="{name: 'panel-accounts'}">
                              Data Pengguna Siakad
                            </nuxt-link>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="columns is-vcentered">
              <div class="column"></div>
              <div
                v-if="user.is_admin || (!isEmpty(pt) && pt.type == 'ADMIN') || !isEmpty(user.permissionNames)"
                class="column is-narrow"
              >
                <b-tooltip
                  label="Jelajah"
                  position="is-bottom"
                  type="is-dark"
                >
                  <nuxt-link :to="{name: 'panel-groups-explore'}">
                    <span
                      class="icon"
                      style="padding-top: 7px;"
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.0704 0.501833C16.9713 0.428335 12.2959 2.57028 9.33611 5.89476C6.50753 5.94857 3.75377 7.10748 1.72586 9.13524C1.60773 9.25205 1.56573 9.4253 1.61692 9.58279C1.66942 9.74029 1.80593 9.85578 1.97131 9.87941L5.34329 10.3624L4.92721 10.8283C4.77232 11.0016 4.7802 11.2654 4.94427 11.4294L10.5686 17.0534C10.6539 17.1387 10.7655 17.182 10.8784 17.182C10.9821 17.182 11.0871 17.1452 11.1698 17.0704L11.6357 16.6544L12.1187 20.0261C12.1424 20.1901 12.2723 20.3109 12.4285 20.3634C12.4692 20.3765 12.5112 20.3831 12.5532 20.3831C12.6766 20.3831 12.8039 20.3293 12.8919 20.2426C14.8922 18.2438 16.0499 15.4902 16.1037 12.6618C19.4324 9.69698 21.5915 5.02328 21.497 0.928385C21.4931 0.696078 21.3041 0.508396 21.0704 0.501833ZM17.0382 8.05508C16.6117 8.48163 16.0512 8.69425 15.492 8.69425C14.9316 8.69425 14.3711 8.48163 13.9445 8.05508C13.0927 7.20198 13.0927 5.8147 13.9445 4.9616C14.7977 4.10849 16.1851 4.10849 17.0382 4.9616C17.8914 5.8147 17.8914 7.20198 17.0382 8.05508Z"
                          fill="#C6E8C5"
                        />
                        <path
                          d="M2.88353 15.2909C1.94636 16.2267 0.661359 20.4581 0.51829 20.9372C0.47235 21.092 0.514352 21.2587 0.628545 21.3716C0.711236 21.4556 0.822805 21.5002 0.936999 21.5002C0.979001 21.5002 1.021 21.4936 1.063 21.4818C1.54209 21.3388 5.77249 20.0526 6.70966 19.1155C7.76496 18.0602 7.76496 16.3448 6.70966 15.2909C5.65436 14.2357 3.93883 14.237 2.88353 15.2909Z"
                          fill="#82BC81"
                        />
                      </svg>
                    </span>
                  </nuxt-link>
                </b-tooltip>
              </div>

              <!-- Package Info -->
              <div class="column is-narrow">
                <b-dropdown
                  id="dropdown-package-info"
                  aria-role="list"
                  position="is-bottom-left"
                >
                  <a
                    ref="packageDropdown"
                    slot="trigger"
                    @click.prevent="getPersonalPackage"
                  >
                    <figure class="image is-30x30">
                      <img
                        src="/assets/img/icon/database.svg"
                        alt=""
                      >
                    </figure>
                  </a>

                  <b-dropdown-item
                    v-if="get_active_package_loading"
                    custom
                    aria-role="listitem"
                  >
                    <spinner-loading />
                  </b-dropdown-item>

                  <span v-else>
                    <b-dropdown-item
                      custom
                      aria-role="listitem"
                    >
                      <p
                        class="title is-6"
                        style="font-weight: 700;"
                      >Personal</p>
                    </b-dropdown-item>
                    <hr class="dropdown-divider">
                    <b-dropdown-item
                      custom
                      aria-role="listitem"
                      has-link
                      class="dropdown-item-hovered"
                    >
                      <nuxt-link
                        style="background: none !important;"
                        :to="{ path: '/panel/media' }"
                      >
                        <div
                          class="columns is-mobile is-vcentered"
                          style="width: 100%;"
                        >
                          <div class="column is-narrow">
                            <figure class="image is-30x30">
                              <img
                                src="/assets/img/icon/external-drive.svg"
                                alt=""
                              >
                            </figure>
                          </div>
                          <div class="column">
                            <p
                              class="has-text-dark"
                              style="margin-bottom: 7px;"
                            >Penyimpanan</p>
                            <div><progress
                              class="progress is-small is-secondary"
                              :value="personal_storage_used"
                              :max="user.activePackage.storageLimit"
                            ></progress></div>
                            <p
                              class="help has-text-grey"
                              style="margin-bottom: 7px;"
                            >{{ formatBytes(personal_storage_used) }} dari {{ formatBytes(user.activePackage.storageLimit) }} Digunakan</p>
                          </div>
                        </div>
                      </nuxt-link>
                    </b-dropdown-item>
                    <hr
                      v-if="!isEmpty(pt) && !isEmpty(pt.university.activePackage)"
                      class="dropdown-divider"
                    >
                    <b-dropdown-item
                      v-if="!isEmpty(pt) && !isEmpty(pt.university.activePackage)"
                      custom
                      aria-role="listitem"
                    >
                      <p
                        class="title is-6"
                        style="font-weight: 700;"
                      >Perguruan Tinggi</p>
                    </b-dropdown-item>
                    <hr
                      v-if="!isEmpty(pt) && !isEmpty(pt.university.activePackage) && (isAdmin || isTeacher)"
                      class="dropdown-divider"
                    >
                    <b-dropdown-item
                      v-if="!isEmpty(pt) && !isEmpty(pt.university.activePackage)"
                      custom
                      aria-role="listitem"
                      has-link
                      class="dropdown-item-hovered"
                    >
                      <nuxt-link
                        style="background: none !important;"
                        :to="{ path: '/panel/media' }"
                      >
                        <div
                          class="columns is-mobile is-vcentered"
                          style="width: 100%;"
                        >
                          <div class="column is-narrow">
                            <figure class="image is-30x30">
                              <img
                                src="/assets/img/icon/external-drive.svg"
                                alt=""
                              >
                            </figure>
                          </div>
                          <div class="column">
                            <p
                              class="has-text-dark"
                              style="margin-bottom: 7px;"
                            >Penyimpanan</p>
                            <div><progress
                              class="progress is-small is-secondary"
                              :value="account_storage_used"
                              :max="pt.university.activePackage.storageLimit"
                            ></progress></div>
                            <p
                              class="help has-text-grey"
                              style="margin-bottom: 7px;"
                            >{{ formatBytes(account_storage_used) }} dari {{ formatBytes(pt.university.activePackage.storageLimit) }} Digunakan</p>
                          </div>
                        </div>
                      </nuxt-link>
                    </b-dropdown-item>
                    <hr
                      v-if="!isEmpty(account) && account.type == 'ADMIN'"
                      class="dropdown-divider"
                    >
                    <div
                      v-if="!isEmpty(account) && account.type == 'ADMIN'"
                      class="card box is-boxed-3 has-background-greystroke flex-row"
                      style="margin: 16px; padding: 20px;"
                    >
                      <img
                        src="/assets/img/icon/important-icon.svg"
                        alt=""
                        style="width: 20px; height: 20px; margin-right: 10px;"
                      >
                      <p class="font-14 has-text-blue font-w-400">Info host Zoom kami pindahkan ke Halaman Beranda. Klik di <a
                        href="#"
                        class="font-w-600 has-text-blue"
                        @click="showGuidelineZoom"
                      >sini</a></p>
                    </div>
                    <hr
                      v-if="!isEmpty(pt) && !isEmpty(pt.university.activePackage) && (isAdmin || isTeacher) && pt.university.activePackage.videoConferenceLimit <= 0"
                      class="dropdown-divider"
                    >
                    <b-dropdown-item
                      v-if="!isEmpty(pt) && !isEmpty(pt.university.activePackage) && (isAdmin || isTeacher) && pt.university.activePackage.videoConferenceLimit <= 0"
                      custom
                      aria-role="listitem"
                      has-link
                    >
                      <a
                        class="is-bg-white-ter"
                        @click.prevent="showSupportContact"
                      >
                        <p class="has-text-link"><strong>UPGRADE TO PRO</strong></p>
                      </a>
                    </b-dropdown-item>
                  </span>
                </b-dropdown>
              </div>

              <!-- Notifications -->
              <div class="column is-narrow">
                <b-dropdown
                  id="dropdown-notifications"
                  aria-role="list"
                  position="is-bottom-left"
                >
                  <a
                    slot="trigger"
                    @click.prevent="showNotifications"
                  >
                    <div
                      class="is-relative"
                      style="padding-top: 7px;"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 22.4996C13.6569 22.4996 15 21.1564 15 19.4996C15 19.4715 14.9996 19.4435 14.9988 19.4155C14.9922 19.1736 14.7823 18.9976 14.5403 18.9948L9.47169 18.9374C9.22965 18.9346 9.01585 19.1058 9.00379 19.3475C9.00127 19.3979 9 19.4486 9 19.4996C9 21.1564 10.3431 22.4996 12 22.4996Z"
                          fill="#C6E8C5"
                        />
                        <path
                          d="M5 9C5 5.13401 8.13401 1.5 12 1.5C15.866 1.5 19 5.13401 19 9V11.4607C19 12.7578 19.5547 13.9931 20.5242 14.8549C21.5645 15.7796 20.9104 17.5 19.5185 17.5H4.48147C3.08955 17.5 2.43545 15.7796 3.47579 14.8549C4.4453 13.9931 5 12.7578 5 11.4607V9Z"
                          fill="#C6E8C5"
                        />
                      </svg>

                      <b-tag
                        v-if="count_unread_notif > 0"
                        rounded
                        style="position: absolute; top: -6px; left: 10px;"
                        type="is-secondary"
                      >{{ count_unread_notif }}</b-tag>
                    </div>
                  </a>

                  <b-dropdown-item
                    v-if="notifications_loading"
                    custom
                    aria-role="listitem"
                  >
                    <spinner-loading />
                  </b-dropdown-item>

                  <span v-else>
                    <b-dropdown-item
                      v-for="(notif, key) in showed_notifications"
                      :key="key"
                      aria-role="listitem"
                      style="border-bottom: 1px solid #f5f5f5; outline: none;"
                      @click="redirectTo(notif)"
                    >
                      <div
                        class="columns is-mobile"
                        style="overflow: hidden;"
                      >
                        <div class="column">
                          <div
                            class="content"
                            style="marbin-bottom: 0;"
                          >
                            <h5 class="title font-14 font-w-600 has-text-dark">{{ notif.title }}</h5>
                            <p class="subtitle font-12 has-text-grey">
                              {{ notif.body }}
                            </p>
                            <p class="subtitle font-12 has-text-primary2">
                              {{ date_humanize(notif.createdAt) }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </b-dropdown-item>
                    <hr
                      class="navbar-divider"
                      style="margin: 0;"
                    >
                    <b-dropdown-item
                      v-if="showed_notifications.length > 0"
                      aria-role="listitem"
                      @click="$router.push({ name: 'panel-notifications'})"
                    >
                      <h5 class="subtitle font-12 font-w-500">Lihat Semua Pemberitahuan</h5>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="showed_notifications.length <= 0"
                      aria-role="listitem"
                      @click="$router.push({ name: 'panel-notifications'})"
                    >
                      <h5 class="subtitle font-12 has-text-grey">Tidak ada Pemberitahuan.</h5>
                    </b-dropdown-item>
                  </span>
                </b-dropdown>
              </div>
              <div class="column is-narrow">
                <b-dropdown
                  hoverable
                  aria-role="list"
                  position="is-bottom-left"
                >
                  <nuxt-link
                    slot="trigger"
                    :to="{name: 'profile-username', params: {username: user.email}}"
                  >
                    <div class="columns is-gapless is-vcentered">
                      <div
                        class="column is-narrow"
                        style="margin-right: 12px;"
                      >
                        <figure
                          slot="trigger"
                          class="image is-42x42 is-circle"
                        >
                          <avatar
                            :is_self="true"
                            input-style="box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08); max-height: none;"
                          ></avatar>
                        </figure>
                      </div>

                      <div class="column">
                        <p class="title font-14 font-w-600 has-text-white">
                          {{ user.name }}
                        </p>
                        <div class="subtitle font-12 font-w-600 has-text-lightprimary">
                          <span v-if="!isEmpty(pt) && pt.type == 'LECTURER'">Dosen</span>
                          <span v-else-if="!isEmpty(pt) && pt.type == 'STUDENT'">Mahasiswa</span>
                          <span v-else-if="!isEmpty(pt) && pt.type == 'ADMIN'">Admin</span>
                          <span v-else>Tamu</span>
                        </div>
                      </div>
                    </div>
                  </nuxt-link>

                  <b-dropdown-item
                    v-if="!isEmpty(pt) && !isEmpty(pt.university) && !isEmpty(pt.university.activePackage) && !isEmpty(pt.university.activePackage.name)"
                    aria-role="listitem"
                    class="has-text-primary"
                  >
                    <span class="icon"><i class="fas fa-crown"></i></span>
                    <span class="font-w-600">{{ pt.university.activePackage.name }}</span>
                  </b-dropdown-item>
                  <hr
                    v-if="!isEmpty(pt) && !isEmpty(pt.university) && !isEmpty(pt.university.activePackage) && !isEmpty(pt.university.activePackage.name)"
                    class="dropdown-divider"
                  >
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="$router.push({ name: 'profile-username', params: { username: user.email } })"
                  >
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Profil</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="$router.push({ name: 'panel-university' })"
                  >
                    <span class="icon"><i class="far fa-building"></i></span>
                    <span>Sambungkan akun</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="$router.push({ name: 'panel-media' })"
                  >
                    <span class="icon"><i class="fas fa-images"></i></span>
                    <span>Media Library</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    has-link
                  >
                    <a
                      href="https://drive.google.com/drive/folders/1MXiqyFW0WU1BoURHkRFOjUix3SPqBBSA"
                      target="_blank"
                      rel="noopener"
                    >
                      <span class="icon"><i class="far fa-file-alt"></i></span>
                      <span>User Guide</span>
                    </a>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="$router.push({ name: 'panel-edlorders' })"
                  >
                    <span class="icon"><i class="fas fa-money-bill-wave"></i></span>
                    <span>Pembelian Kelas</span>
                  </b-dropdown-item>
                  <hr class="dropdown-divider">
                  <b-dropdown-item
                    class="has-text-darkred"
                    aria-role="listitem"
                    has-link
                  >
                    <nuxt-link :to="{name: 'panel-profile'}">
                      <span class="icon"><i class="fas fa-cog"></i></span>
                      <span>Pengaturan</span>
                    </nuxt-link>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="(!isEmpty(user.activeAccount) && user.activeAccount.isLeader == true) || isAdmin"
                    class="has-text-black"
                    aria-role="listitem"
                    @click="changeDashboard"
                  >
                    <span class="icon"><i class="fas fa-retweet"></i></span>
                    <span>Ubah Dashboard</span>
                  </b-dropdown-item>
                  <hr class="dropdown-divider">
                  <b-dropdown-item
                    class="has-text-darkred"
                    aria-role="listitem"
                    @click="logout"
                  >
                    <span class="icon"><i class="fas fa-sign-out-alt"></i></span>
                    <span>Keluar</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { INTEGRATION } from '~/consts';
import CLASSMATE_MIXINS from '~/mixins/classmate';
import DownloadAppNotif from '~/components/DownloadAppNotif'

export default {
  components: {
    DownloadAppNotif
  },

  mixins: [CLASSMATE_MIXINS],

  data() {
    return {
      university_news: false,
      show_navbar_head: true,
      show_notif: false,
      show_quota: false,
      show_user_options: false,
      group_search_query: '',
      loading: false,
      loading_get_news: false,
      show_universities: false,
      show_mobile_menu: false,
      show_integration_usage: false,
      integration_usage: {
        hosts: 0,
        usage: 0
      },
      left_menus: [
        { value: 'panel', name: 'Beranda', data_tab: 'dashboard', icon: 'fas fa-home' },
        { value: 'panel/classes', name: 'Kelas Akademik', data_tab: 'classes', icon: 'fas fa-graduation-cap', roles: ['ADMIN', 'LECTURER', 'STUDENT'] },
        { value: 'panel/groups', name: 'Kelas Umum', data_tab: 'group-discussion', icon: 'fas fa-users' },
        { value: 'panel/messages', name: 'Pesan', data_tab: 'message', icon: 'fas fa-comments' },
        {
          value: '',
          name: 'Perguruan Tinggi',
          data_tab: 'learning',
          icon: 'fas fa-university',
          roles: ['ADMIN'],
          submenus: [
            { value: 'panel/admin/classes', name: 'Data Kelas', data_tab: 'data-classes', icon: 'fas fa-chalkboard' },
            { value: 'panel/admin/accounts', name: 'Data Pengguna', data_tab: 'data-accounts', icon: 'fas fa-users', line: true },
            { value: 'panel/admin/news', name: 'Berita Kampus', data_tab: 'university-news', icon: 'fas fa-newspaper-o', line: true },
            { value: 'panel/admin/settings', name: 'Pengaturan', data_tab: 'settings', icon: 'fas fa-cogs' }
          ]
        },
        { value: 'panel/news', name: 'Berita', icon: 'fas fa-newspaper-o', whitelist_email: ['edlink.sevima@gmail.com'] },
        { value: 'panel/accounts', name: 'Akun Siakad', icon: 'fas fa-users', whitelist_email: ['edlink.sevima@gmail.com'] },
        { value: 'panel/users', name: 'Pengguna', icon: 'fas fa-users', whitelist_email: ['edlink.sevima@gmail.com'] },
        {
          value: '',
          name: 'Laporan',
          icon: 'fas fa-area-chart',
          whitelist_email: ['edlink.sevima@gmail.com'],
          submenus: [
            { value: 'panel/reports', name: 'Perguruan Tinggi', icon: 'fas fa-university' },
            { value: 'panel/reports/posts', name: 'Postingan', icon: 'fas fa-stream' },
            { value: 'panel/reports/stats', name: 'Statistik', icon: 'far fa-area-chart' },
          ]
        },
      ],
      right_menus: [
        // { value: 'panel/ebook/discover', name: 'E-Book', data_tab: 'explore', icon: 'fas fa-book', tag: 'warning', tag_text: 'Gratis' },
        { value: 'panel/groups/explore', name: 'Jelajahi', data_tab: 'explore', icon: 'fas fa-globe' },
        {
          value: '',
          name: 'Sistem',
          icon: 'fas fa-cogs',
          whitelist_email: ['edlink.sevima@gmail.com'],
          submenus: [
            { value: 'panel/system/packages', name: 'Paket', icon: 'fas fa-box' },
            { value: 'panel/system/queues', name: 'Queue', icon: 'fas fa-university' },
          ]
        },
      ],
      timer_search: null
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth,
      account: state => !helpers.isEmpty(state.auth) && !helpers.isEmpty(state.auth.active_pt) ? state.auth.active_pt : null,
      notifications: state => state.notifications.list,
      count_unread_notif: state => state.notifications.count_unread,
      notifications_loading: state => state.notifications.get_list_loading,
      notifications_has_been_taken: state => state.notifications.list_has_been_taken,
      pt: state => !helpers.isEmpty(state.auth) && !helpers.isEmpty(state.auth.active_pt) ? state.auth.active_pt : null,
      public_groups: state => state.groups.public,
      loading_search: state => state.groups.loading_search,
      news: state => state.news.all,
      my_pt: state => state.universities.me,
      get_active_package_loading: state => state.get_active_package_loading,
      active_package_has_been_taken: state => state.active_package_has_been_taken,
      personal_storage_used: state => state.personal_storage_used,
      account_storage_used: state => state.account_storage_used,
      account_class_used: state => state.account_class_used,
      account_conferences_used: state => state.account_conferences_used,
      account_periode: state => state.account_periode,
      university: state => state.universities.active,
      personal_package_dropdown: function (state) {
        const showDropdown = state.personal_package_dropdown
        return showDropdown;
      }
    }),
    my_universities() {
      if (!this.isEmpty(this.pt)) {
        return collect(this.my_pt).where('id', '!=', this.pt.id).toArray();
      }

      return [];
    },
    new_news_count() {
      return collect(this.news).where('is_new', '==', 1).count();
    },
    unread_notifications() {
      return collect(this.notifications).where('is_read' , '==', 0).toArray();
    },
    showed_notifications() {
      return collect(this.notifications).take(5).toArray();
    },
  },

  watch: {
    '$route' () {
      this.group_search_query = '';
      this.$store.commit('groups/setPublicGroups', []);
      this.show_mobile_menu = false;
    },
    personal_package_dropdown() {
      this.openPackageDropdown();
    }
  },

  mounted() {
    this.getCountUnread();
    this.getNews();
  },

  methods: {
    ...mapActions({
      logout: 'logout',
      setDefaultPT: 'universities/setDefault',
      removePT: 'universities/removePT',
      getCountUnread: 'notifications/getCountUnread',
      getNotifications: 'notifications/getList',
      pushNotif: 'notifications/pushNotif',
      setRead: 'notifications/setRead',
      getPublicGroups: 'groups/getPublicGroups',
      getNews: 'news/getAll',
      // getRunnedQuiz: 'quizes/getRunnedQuiz'
    }),
    isNotCommunityPackage() {
      return !this.isEmpty(this.user.activeAccount) && !this.isEmpty(this.user.activeAccount.university.activePackage) &&
        this.user.activeAccount.university.activePackage.slug != 'community' &&
        this.user.activeAccount.university.activePackage.slug != 'community-plus';
    },
    getPersonalPackage() {
      if (this.active_package_has_been_taken === false) {
        this.$store.dispatch('getStorageUsed');

        if (this.isNotCommunityPackage() && (this.isAdmin || this.isTeacher)) {
          this.$axios.post(INTEGRATION.ZOOM_USAGE).then(({ data }) => {
            if (data.applicationSystem.code == 0) {
              this.show_integration_usage = true;
              this.integration_usage = data.data;
            } else {
              this.show_integration_usage = false;
            }
          })
        }
      }
    },
    showNotifications() {
      if (this.isEmpty(this.notifications_has_been_taken)) {
        this.getNotifications();
      }
    },
    isEmpty(data) {
      return helpers.isEmpty(data);
    },
    search() {
      const vm = this;

      if (vm.timer_search) {
        clearTimeout(vm.timer_search);
        vm.timer_search = null;
      }

      vm.timer_search = setTimeout(() => {
        const val = vm.group_search_query;

        if (!vm.isEmpty(val) && val.length > 0) {
          vm.getPublicGroups({
            query: val,
            per_page: 5,
            page: 1
          });
        } else {
          this.$store.commit('groups/setPublicGroups', [])
        }
      }, 800)
    },
    strip_tags(html) {
      return !this.isEmpty(html) ? helpers.strip_tags(html).replace(/&nbsp;/gi,' ') : '';
    },
    redirectTo(notif) {
      this.setRead(notif.id);

      this.$router.push({ path: notif.click_action });
    },
    isCan(menu) {
      const pt = this.pt;
      let is_can = false;

      if (this.user !== null && this.user !== undefined && menu.whitelist_email !== null && menu.whitelist_email !== undefined && menu.whitelist_email.indexOf(this.user.email) > -1) {
        is_can = true;
      } else if (pt !== null && pt !== undefined && menu.roles !== undefined && menu.roles.indexOf(pt.type) > -1) {
        is_can = true;
      } else if ((menu.roles === null || menu.roles === undefined) && (menu.whitelist_email == undefined || menu.whitelist_email == null)) {
        is_can = true;
      }

      return is_can;
    },
    showSupportContact() {
      this.$buefy.dialog.alert({
        title: 'Hubungi Kami',

        message: `
          <div class="field" style="margin-top: 0;">
            <label class="label">Email</label>
            <div class="control">
              <input class="input" type="text" value="support@sevima.com" readonly>
            </div>
          </div>
          <div class="field" style="margin-top: 0;">
            <label class="label">Nomer Telepon</label>
            <div class="control">
              <input class="input" type="text" value="+62 812-9000-4560" readonly>
            </div>
          </div>
          <a href="https://wa.me/6281290004560" target="_blank" rel="noopener" class="button is-success is-fullwidth">
            <span class="icon"><i class="fas fa-phone"></i></span>
            <span>Hubungi Kami</span>
          </a>
        `,
        confirmText: 'Okay!'
      })
    },
    openPackageDropdown() {
      this.$refs.packageDropdown.click();
    },
    showGuidelineZoom() {
      const path = this.$route.path;
      if (path !== "/panel" || path !== "/panel/") {
        this.$router.push('/panel/')
      }
      window.scrollTo(0,0);
      document.documentElement.style.overflow = 'hidden';
      this.$store.dispatch('dropdownPersonalPackage', { value: (this.personal_package_dropdown) ? false :  true });
      this.$store.dispatch('toogleGuidelineZoom', { value: true });
    },
    changeDashboard() {
      if (!this.isEmpty(this.user.activeAccount) && this.user.activeAccount.isLeader == true) {
        const value = !this.show_leader_dashboard
        this.$store.commit('setState', {key: 'show_leader_dashboard', value: value});
      } else {
        const value = !this.show_dashboard_admin
        this.$store.commit('setState', {key: 'show_dashboard_admin', value: value});
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.tabs .is-active.link-menu {
  color: #279B24 !important;
  font-weight: 700;
}
.tabs .is-active.link-submenu {
  color: white !important;
  font-weight: 700;
}

.navbar-item.has-dropdown:hover .navbar-link, .navbar-item.has-dropdown.is-active .navbar-link, .btn-search, .btn-search:hover {
  background: transparent;
}

.navbar-dropdown {
  box-shadow: 0 2px 3px rgba(56,59,61,.05);
  border: none;
  border-bottom-left-radius: 3px !important;
  border-bottom-right-radius: 3px !important;
}

.navbar-link:after {
  border-color: white !important;
}

li a, .universitas-header button {
  color: rgba(207,219,230,.75);

  &:hover {
    color: white;
  }
}
</style>

<style>
.avatar-navbar {
  border: 2px solid white;
  background-color: white;
}
.navbar-wrapper {
  z-index: 30;
  width: 100%;
  top: 0;
}
.toggle-notif {
  padding: 0;
}
.notif-text {
  border-bottom: 1px solid #e3e8ee;
}
.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
  transition: width 1s;
}
.sticky #stickyable-navbar {
  max-width: 100%;
}

#dropdown-package-info .dropdown-content, #dropdown-notifications .dropdown-content {
  overflow: auto;
  max-height: 67vh;
  width: 300px;
}
</style>
